import OwButton from "@components/shared/OwButton/OwButton";
import { OwLabel } from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import WhatsThis from "@components/shared/WhatsThis/WhatsThis";
import SupplierContext from "@contexts/SupplierContext";
import ICatalog from "@models/ICatalog";
import IPrice_Group from "@models/IPrice_Group";
import ISupplier_Integration from "@models/ISupplier_Integration";
import QBDSkuPropertyEnum from "@models/QBDSkuPropertyEnum";
import _ from "lodash";
import React, { useContext, useState } from "react";
import { QbdDataImportOptionsSidebar } from "../QbdDataImportOptionsSidebar/QbdDataImportOptionsSidebar";
import UiContext from "@contexts/UiContext";
import { QbdUomMappingsSidebar } from "../QbdUomMappingsSidebar/QbdUomMappingsSidebar";
import TitleTagEnum from "@models/TitleTagEnum";
import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";

type Props = {
    handleChange: (e: React.ChangeEvent<any>) => void;
    borderClass: string;
    catalogs: ICatalog[];
};

export const QuickbooksDesktopConfigItemsSection = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const uiContext = useContext(UiContext);

    const [supplierIntegration, setSupplierIntegration] = useState({
        qbd_has_price_levels: supplierModel.Supplier_Integration.qbd_has_price_levels || false,
        qbd_use_mfg_sku_for_mfg_pt_no: supplierModel.Supplier_Integration.qbd_use_mfg_sku_for_mfg_pt_no || false,
        qbd_skip_product_group_creation: supplierModel.Supplier_Integration.qbd_skip_product_group_creation || false,
        qbd_AutoPullAndProcessCatalogItems: supplierModel.Supplier_Integration.qbd_AutoPullAndProcessCatalogItems || false,
        qbd_AllowCreateItems: supplierModel.Supplier_Integration.qbd_AllowCreateItems || false,
        qbd_AllowUpdateItems: supplierModel.Supplier_Integration.qbd_AllowUpdateItems || false,
        qbd_DefaultTaxRate: supplierModel.Supplier_Integration.qbd_DefaultTaxRate || "",
        qbd_DefaultIncomeAccount: supplierModel.Supplier_Integration.qbd_DefaultIncomeAccount || "",
        qbd_DefaultAssetAccount: supplierModel.Supplier_Integration.qbd_DefaultAssetAccount || "",
        qbd_DefaultCOGSAccount: supplierModel.Supplier_Integration.qbd_DefaultCOGSAccount || "",
        qbd_PriceToCatalogId: supplierModel.Supplier_Integration.qbd_PriceToCatalogId || "",
        qbd_PriceToPriceGroupId: supplierModel.Supplier_Integration.qbd_PriceToPriceGroupId || "",
        qbd_CatItemSkuProperty: supplierModel.Supplier_Integration.qbd_CatItemSkuProperty || "",
        qbd_ignore_qty_on_hand: supplierModel.Supplier_Integration.qbd_ignore_qty_on_hand || false,
    });

    const { qbd_SalesTaxOptions, qbd_IncomeAccountOptions, qbd_AssetAccountOptions, qbd_COGSAccountOptions } =
        supplierModel.Supplier_Integration;

    const salesTaxOptions = _.isString(qbd_SalesTaxOptions) ? JSON.parse(qbd_SalesTaxOptions || "") : qbd_SalesTaxOptions;
    const incomeAccountOptions = _.isString(qbd_IncomeAccountOptions)
        ? JSON.parse(qbd_IncomeAccountOptions || "")
        : qbd_IncomeAccountOptions;

    const assetAccountOptions = _.isString(qbd_AssetAccountOptions) ? JSON.parse(qbd_AssetAccountOptions || "") : qbd_AssetAccountOptions;

    const cogsAccountOptions = _.isString(qbd_COGSAccountOptions) ? JSON.parse(qbd_COGSAccountOptions || "") : qbd_COGSAccountOptions;

    const catalogItemSkuProperty: { value: QBDSkuPropertyEnum; title: QBDSkuPropertyEnum }[] = [
        { value: QBDSkuPropertyEnum.Name, title: QBDSkuPropertyEnum.Name },
        { value: QBDSkuPropertyEnum.FullName, title: QBDSkuPropertyEnum.FullName },
        { value: QBDSkuPropertyEnum.ManufacturerPartNumber, title: QBDSkuPropertyEnum.ManufacturerPartNumber },
        { value: QBDSkuPropertyEnum.Description, title: QBDSkuPropertyEnum.Description },
    ];

    let priceGroups: IPrice_Group[] = [];

    if (supplierIntegration.qbd_PriceToCatalogId) {
        for (const catalog of props.catalogs) {
            if (catalog.id === Number(supplierIntegration.qbd_PriceToCatalogId)) {
                priceGroups = catalog.Price_Groups || [];
            }
        }
    }

    const handleChange = (e: React.ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const updatedSupplierIntegration = {
            ...supplierIntegration,
            [name]: value,
        };

        setSupplierIntegration(updatedSupplierIntegration);

        props.handleChange(e);
    };

    const closeSidebar = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const editDataImportOptions = () => {
        const sidebarComponent = <QbdDataImportOptionsSidebar closeSidebar={closeSidebar} />;

        uiContext.setSidebarComponent(sidebarComponent);
        uiContext.toggleSidebar(true);
    };

    const editUomMappings = () => {
        const sidebarComponent = <QbdUomMappingsSidebar closeSidebar={closeSidebar} />;

        uiContext.setSidebarComponent(sidebarComponent);
        uiContext.toggleSidebar(true);
    };

    return (
        <div className={"QuickbooksDesktopConfigItemsSection mb-2"}>
            <OwAccordion title={"items"} fullWidthClick={true} titleTag={TitleTagEnum.H5}>
                <div className={"col-12 card " + props.borderClass} data-id={"qbd-items-card"}>
                    <div className="card-body">
                        {supplierModel.Supplier_Integration.qbd_UnitOfMeasureOptions ? (
                            <div className="">
                                <OwButton title={"edit_uom_mappings"} fn={editUomMappings} />
                            </div>
                        ) : null}

                        <div className="mt-4">
                            <OwButton title={"edit_data_import_options"} fn={editDataImportOptions} />
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"price_levels"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_has_price_levels"} />
                            <div>
                                <OwToggle
                                    fn={handleChange}
                                    name={"qbd_has_price_levels"}
                                    label={"enable_price_levels"}
                                    active={supplierIntegration.qbd_has_price_levels}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"sales_tax_options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_sales_tax_options_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={props.handleChange}
                                    name={"qbd_DefaultTaxRate"}
                                    options={salesTaxOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_DefaultTaxRate"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"income_account_options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_income_account_options_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={props.handleChange}
                                    name={"qbd_DefaultIncomeAccount"}
                                    options={incomeAccountOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_DefaultIncomeAccount"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"asset_account_options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_asset_account_options_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={props.handleChange}
                                    name={"qbd_DefaultAssetAccount"}
                                    options={assetAccountOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_DefaultAssetAccount"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"cogs_account_options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_cogs_account_options_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={props.handleChange}
                                    name={"qbd_DefaultCOGSAccount"}
                                    options={cogsAccountOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_DefaultCOGSAccount"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <div>
                                <OwLabel isBold={true} title={"price_to_price_group"} />
                                <WhatsThis subject={"qbd_price_to_price_group"} />
                            </div>
                            <div>
                                <div>
                                    <OwSelectOption
                                        name={"qbd_PriceToCatalogId"}
                                        options={props.catalogs}
                                        fn={props.handleChange}
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        selectedOption={supplierIntegration}
                                        selectedOptionProp={"qbd_PriceToCatalogId"}
                                    />
                                </div>

                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbd_PriceToPriceGroupId"}
                                        options={priceGroups}
                                        fn={props.handleChange}
                                        titleProp={"value"}
                                        valueProp={"id"}
                                        selectedOption={supplierIntegration}
                                        selectedOptionProp={"qbd_PriceToPriceGroupId"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <div>
                                <OwLabel isBold={true} title={"catalog_item_sku_property"} />
                                <WhatsThis subject={"qbd_catalog_item_sku_property"} />
                            </div>
                            <div>
                                <OwSelectOption
                                    fn={props.handleChange}
                                    name={"qbd_CatItemSkuProperty"}
                                    options={catalogItemSkuProperty}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_CatItemSkuProperty"}
                                    valueProp={"value"}
                                    titleProp={"title"}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_use_mfg_sku_for_mfg_pt_no"}
                                label={"use_mfg_sku_for_mfq_part_no"}
                                active={supplierIntegration.qbd_use_mfg_sku_for_mfg_pt_no}
                                labelOnRight={true}
                            />
                        </div>

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_skip_product_group_creation"}
                                label={"skip_product_group_creation"}
                                active={supplierIntegration.qbd_skip_product_group_creation}
                                labelOnRight={true}
                            />
                        </div>

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_AutoPullAndProcessCatalogItems"}
                                label={"auto_pull_and_process_items"}
                                active={supplierIntegration.qbd_AutoPullAndProcessCatalogItems}
                                labelOnRight={true}
                            />
                        </div>
                        <WhatsThis subject={"qbd_allow_create_items"} className={"mt-4"} />
                        <div>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_AllowCreateItems"}
                                label={"allow_create_items"}
                                active={supplierIntegration.qbd_AllowUpdateItems}
                                labelOnRight={true}
                            />
                        </div>
                        <WhatsThis subject={"qbd_allow_item_updates"} className={"mt-4"} />
                        <div>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_AllowUpdateItems"}
                                label={"allow_item_updates"}
                                active={supplierIntegration.qbd_AllowUpdateItems}
                                labelOnRight={true}
                            />
                        </div>
                        <div className={"mt-4"}>
                            <OwToggle
                                fn={props.handleChange}
                                name={"qbd_ignore_qty_on_hand"}
                                label={"ignore_qty_on_hand"}
                                active={supplierIntegration.qbd_ignore_qty_on_hand}
                                labelOnRight={true}
                            />
                        </div>
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
